import { render, staticRenderFns } from "./InReview.vue?vue&type=template&id=3cac5726&"
import script from "./InReview.vue?vue&type=script&lang=js&"
export * from "./InReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports